import { Component, OnInit, OnDestroy, Input, Output, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'academic-programs-component',
  templateUrl: './academic.programs.component.html'
})
export class AcademicProgramsComponent implements OnInit, OnDestroy {
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() jsclassinit:any;
  @Input() value:any;
  @Input() disabled:boolean;
  @Input() required:boolean;

  canAddOther:boolean=false;
  hasOther:boolean=false;
  other:string='';
  validationMessages: any;
  formSegment:FormGroup;
  _touched:boolean=false;

  public getValue(){
    var result={},value=[];
    if(!this.disabled) {

      if(this.hasOther) {
        value.push(this.other);
      }
      for(let i in this.formSegment.controls) {
        if(this.formSegment.controls[i].value) {
          value.push(i);
        }
      }
      result[this.questionid]=value;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  constructor() {
  }

  get touched():boolean {
    if(this._touched) {
      return true;
    }
    for(let i in this.formSegment.controls) {
      if(this.formSegment.controls[i].touched || this.formSegment.controls[i].dirty) {
        this._touched=true;
        return true;
      }
    }
    return false;
  }

  isValid():boolean {
    var value;
    if(!this.disabled && this.required) {
      for(let i in this.formSegment.controls) {
        if(!!this.formSegment.controls[i].value) {
          return true;
        }
      }
      if (this.canAddOther && this.hasOther && !!this.other) {
        return true;
      }
      return false;
    }
    return true;
  }
  validate():boolean {
    this._touched=true;
    return this.isValid();
  }

  ngOnInit() {
    var init={};
    if(this.value===null) {
      this.value=Array();
    }
    if('jsclassinit' in this) {
      if(!!this.jsclassinit && !!this.jsclassinit.canAddOther) {
        this.canAddOther=true;
      }
      this.jsclassinit.programs.forEach((programname)=>{
        init[programname]=new FormControl();
      });
    }
    this.formSegment=new FormGroup(init);

    if(!!this.value) {
      this.value.forEach((item)=>{
        if(item in this.formSegment.controls) {
          this.formSegment.controls[item].setValue(true);
        } else if (this.canAddOther) {
          this.hasOther=true;
          this.other=item;
        }
      });
    }
  }

  ngOnDestroy() {
  }
}




// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/academic.programs.component.ts